module.exports = __webpack_public_path__ + "static/confetti-11aaaec43628611bb62716aa4c22a073.mp4";